import React, { useEffect } from "react";

const SubscribepopupModel = () => {

  const handleClose = (val) => {
    // Store preference so popup doesn't show again
    localStorage.setItem("newsletterPopupClosed", "true");

    // If they clicked subscribe button
    if (val === "subscribe") {
      window.location.href = "/#newsletter";
    }
  };

  useEffect(() => {
    // If stored value exists → don't show popup
    const alreadyClosed = localStorage.getItem("newsletterPopupClosed");
    if (alreadyClosed === "true") return;

    // Otherwise trigger modal automatically
    const handlePageLoad = () => {
      const modal = document.getElementById("k-success-modal");
      if (modal) modal.click();
    };

    window.addEventListener("load", handlePageLoad);

    return () => {
      window.removeEventListener("load", handlePageLoad);
    };
  }, []);

  return (
    <>
      <span
        id="k-success-modal"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
      ></span>

      <div className="modal" id="exampleModal" tabIndex="-1">
        <div className="modal-dialog modal-md" role="document">
          <div className="modal-content">
            <button
              onClick={() => handleClose("close")}
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>

            <div className="modal-status bg-success"></div>

            <div className="modal-body text-center py-4">
              <h3>Stay Updated With the Latest Insights</h3>
              <div className="text-secondary">
                Join our weekly newsletter and never miss important updates,
                expert tips, and exclusive offers curated just for you.
                <ul className="list-unstyled mt-4">
                  <li className="mt-3 text-center">✔ Fresh content every week</li>
                  <li className="mt-3 text-center">✔ No spam — unsubscribe anytime</li>
                  <li className="mt-3 text-center">✔ Trusted by thousands of readers</li>
                </ul>
              </div>
            </div>

            <div className="modal-footer">
              <div className="w-100">
                <div className="row">
                  <div className="col">
                    <span
                      className="btn w-100 text-wrap"
                      data-bs-dismiss="modal"
                      onClick={() => handleClose("close")}
                    >
                      I have Already Subscribed
                    </span>
                  </div>

                  <div className="col">
                    <button
                      className="btn btn-success w-100 text-wrap"
                      data-bs-dismiss="modal"
                      onClick={() => handleClose("subscribe")}
                    >
                      Join Weekly Newsletter
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscribepopupModel;
